import React from "react";
import { useLocation } from "react-router-dom";
import { usePagePrefs } from "../../lib/PagePrefs";
import AllSchedule from "../../pages/AllSchedule";

// All Leagues is a feature, not a page: with 2+ leagues on, each league's own Schedule page
// (same URL, same highlighted tab) shows every league's games.
export function AllGate({ children }) {
    const { getPref } = usePagePrefs();
    const loc = useLocation();
    const multi = (getPref("page_toggle", "all_sched_show") || "").split(",").filter(Boolean).length >= 2;
    if (getPref("page_toggle", "all_sched_on") === "on" && multi && !new URLSearchParams(loc.search).get("game")) return <AllSchedule />;
    return children;
}
